import React from "react";
import { useForm } from "@inertiajs/react";
import Layout from "../../components/Layout";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";

interface Props {
  flash?: {
    alert?: string;
    notice?: string;
  };
  email_address?: string;
}

export default function SessionsNew({ flash, email_address }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    email_address: email_address || "",
    password: "",
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    post("/session");
  };

  return (
    <Layout>
      <div className="h-full bg-green-50">
        <div className="flex flex-col justify-center mx-auto max-w-md h-full">
          <Card>
            <CardHeader>
              <CardTitle className="text-center">⛳ ⛳</CardTitle>
            </CardHeader>
            <CardContent>
              {flash?.alert && (
                <div className="px-4 py-3 mb-4 rounded border bg-destructive/15 border-destructive text-destructive">
                  {flash.alert}
                </div>
              )}
              {flash?.notice && (
                <div className="px-4 py-3 mb-4 text-green-700 bg-green-50 rounded border border-green-200">
                  {flash.notice}
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Input
                    type="email"
                    value={data.email_address}
                    onChange={(e) => setData("email_address", e.target.value)}
                    required
                    autoFocus
                    autoComplete="username"
                    placeholder="📧"
                  />
                  {errors.email_address && (
                    <div className="text-sm text-destructive">
                      {errors.email_address}
                    </div>
                  )}
                </div>

                <div className="space-y-2">
                  <Input
                    type="password"
                    value={data.password}
                    onChange={(e) => setData("password", e.target.value)}
                    required
                    autoComplete="current-password"
                    placeholder="🔒"
                    maxLength={72}
                  />
                  {errors.password && (
                    <div className="text-sm text-destructive">
                      {errors.password}
                    </div>
                  )}
                </div>

                <Button type="submit" disabled={processing} className="w-full">
                  {processing ? "Signing in..." : "Sign in"}
                </Button>
              </form>

              <div className="mt-4 text-center">
                <a
                  href="/passwords/new"
                  className="text-primary hover:underline"
                >
                  Forgot password?
                </a>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </Layout>
  );
}
